module.exports = __webpack_public_path__ + "img/badge-list-thumb-059.6c552c8b.png";